"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFiatWithdrawFee = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _actions = require("../../actions");
var initialState = {
  loading: false,
  data: undefined
};
var getFiatWithdrawFee = (0, _toolkit.createReducer)(initialState, function (builder) {
  builder.addCase(_actions.getFiatWithdrawFeeAction.pending, function (state) {
    state.loading = true;
    state.data = initialState.data;
  }).addCase(_actions.getFiatWithdrawFeeAction.rejected, function (state) {
    state.loading = false;
  }).addCase(_actions.getFiatWithdrawFeeAction.fulfilled, function (state, action) {
    state.loading = false;
    state.data = action.payload;
  }).addCase(_actions.resetGetFiatWithdrawFeeAction, function () {
    return initialState;
  });
});
exports.getFiatWithdrawFee = getFiatWithdrawFee;